var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "15px",
    viewBox: "0 0 13 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient-Video-Visit-3",
    transform: "translate(-467.000000, -381.000000)",
    fill: "#516983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(464.999907, 355.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2.000093, 25.999868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,1.35458998 C8.00314334,1.35458998 9.22611233,2.57755896 9.22611233,4.0807023 C9.22611233,5.58384565 8.00314334,6.80681463 6.5,6.80681463 C4.99685666,6.80681463 3.77388767,5.58384565 3.77388767,4.0807023 C3.77388767,2.57755896 4.99685666,1.35458998 6.5,1.35458998 M9.44329825,6.89982981 C10.1458789,6.16631934 10.5807023,5.17408218 10.5807023,4.0807023 C10.5807023,1.83050259 8.74997395,0 6.5,0 C4.25002605,0 2.4192977,1.83050259 2.4192977,4.0807023 C2.4192977,5.17408218 2.85412108,6.16631934 3.55670175,6.89982981 C1.52888055,7.3197527 0,9.11932548 0,11.2697371 L0,14.162464 C0,14.5367823 0.30320239,14.839759 0.677294988,14.839759 C1.05138759,14.839759 1.35458998,14.5367823 1.35458998,14.162464 L1.35458998,11.2697371 C1.35458998,9.55572922 2.74914036,8.16140461 4.46314821,8.16140461 L8.53685179,8.16140461 C10.2508596,8.16140461 11.64541,9.55572922 11.64541,11.2697371 L11.64541,12.5335695 C11.64541,13.0582474 11.2182627,13.485169 10.693359,13.485169 L3.09659269,13.485169 C2.72272585,13.485169 2.4192977,13.7883714 2.4192977,14.162464 C2.4192977,14.5367823 2.72272585,14.839759 3.09659269,14.839759 L10.693359,14.839759 C11.965319,14.839759 13,13.805078 13,12.5335695 L13,11.2697371 C13,9.11932548 11.4711194,7.3197527 9.44329825,6.89982981",
    id: "Fill-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.ec3361cffd9ed8a7f00f17f7b92834c6.svg";
export { ForwardRef as ReactComponent };